/* tslint:disable */
/* eslint-disable */
/* @relayHash 194f55e96a821b74b02f988a059aff8a */

import { ConcreteRequest } from "relay-runtime";
export type BadgesConfigContainerQueryVariables = {};
export type BadgesConfigContainerQueryResponse = {
    readonly sites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string;
            };
        }>;
    };
    readonly settings: {
        readonly id: string;
    };
};
export type BadgesConfigContainerQuery = {
    readonly response: BadgesConfigContainerQueryResponse;
    readonly variables: BadgesConfigContainerQueryVariables;
};



/*
query BadgesConfigContainerQuery {
  sites {
    edges {
      node {
        id
        name
      }
    }
  }
  settings {
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "SitesConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "Settings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                (v0 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "BadgesConfigContainerQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "BadgesConfigContainerQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "194f55e96a821b74b02f988a059aff8a",
            "metadata": {},
            "name": "BadgesConfigContainerQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9d8a5f571c49d69acc3402b55c95d790';
export default node;
